// extracted by mini-css-extract-plugin
module.exports = {"resultContainerStyle":"lIgCfcXxSroxSr9HSoi8t"};